import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { BaseCMREventDto } from '@shared/src/dtos/route/cmr/BaseCMREventDto';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-events',
    templateUrl: './shared.external.cmr.agent.events.component.html',
    styleUrls: ['./shared.external.cmr.agent.events.component.scss']
})
export class SharedExternalCMRAgentEventsComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    public events: BaseCMREventDto[];
    public getListEvents(){
        if(this.events == null)
            return new Array();
        return this.events;
    }
    loadData() {
        if (!HString.isNullOrNullString(this.uuidQR) && RouteCMRAgentsEnum.isValid(this.agent)) {
            this.openRouteCMRController.getRouteCMRAgentEventsByUUID(this.uuidQR, this.agent).subscribe(data => { 
                this.events = data;
            });
        }
    }


    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
